<template>
  <!--Section One Content-->
  <div class="kids-sec1">
    <div class="text-container">
      <!-- <h3>تعليم الصغار</h3> -->
      <h1>
        تعلم الإنجليزية من خلال <br/> الأكاديمية الأولي عالمياً
      </h1>
      <p>
        متخصصون في تعليم اللغة الإنجليزية للصغار بدءًا من التأسيس بمنهج المعايشة الفريد والحصري
      </p>

      <div class="group-btns">
        <button @click="scrollToPackagesWithDelay">
          تعرف علي باقات المعايشة
        </button>
  
        <button class="white-btn" @click="callToAction">
          احجز حصة مجانية
        </button>
      </div>
    </div>
  </div>

  <!--Section Two Content-->
  <div class="kids-sec2">
    <div class="kids-space">
      <h3>مميزات كورسات اللغة الإنجليزية للأطفال في Monglish</h3>
      <h1>تفتح أبواب المستقبل لطفلك</h1>
      <button @click="sendMessage" id="kids-wa2-ar">
        إشترك معنا الأن
        <img src="https://monglish.b-cdn.net/kids-landing/Whatsapp.png" alt="whatsapp icon">
      </button>
    </div>
    <div class="kids-sec2-cards">
      <div class="sec2-card card-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="106" height="272" viewBox="0 0 106 272" fill="none">
          <path d="M49.1672 63.2H48.3672L5.16719 92.8C2.23386 94.6667 0.76719 93.8667 0.76719 90.4V40.8C0.76719 38.6667 1.70052 36.8 3.56719 35.2L49.1672 2.39999C51.0339 0.799995 53.4339 -2.86102e-06 56.3672 -2.86102e-06H101.167C103.834 -2.86102e-06 105.167 1.33333 105.167 3.99999V268C105.167 270.667 103.834 272 101.167 272H53.1672C50.5005 272 49.1672 270.667 49.1672 268V63.2Z" fill="url(#paint0_linear_718_34540)"></path>
          <defs>
            <linearGradient id="paint0_linear_718_34540" x1="64" y1="-2" x2="64" y2="272" gradientUnits="userSpaceOnUse">
              <stop stop-color="#A8D0FF"></stop>
              <stop offset="1" stop-color="#F1F1F1"></stop>
            </linearGradient>
          </defs>
        </svg>
        <h1>مواعيد دروس التدريب</h1>
        <p>
          مواعيد دروسنا مرنة ومتنوعة، مصممة
          خصيصًا لتناسب جدول طفلك اليومي دون
           أي تأثير سلبي علي دراسته، مما يوفر له
            تجربة تعلم فريدة من نوعها.
        </p>
      </div>
      <div class="sec2-card card-2">
        <svg
          xmlns="http://www.w3.org/2000/svg" width="162" height="263" viewBox="0 0 162 263" fill="none">
          <path d="M0.62383 223.86C0.62383 221.833 1.25716 220.06 2.52383 218.54L93.3438 110.62C98.4105 104.793 102.211 99.0933 104.744 93.52C107.277 87.6933 108.544 81.4867 108.544 74.9C108.544 66.2867 106.01 59.1933 100.944 53.62C96.1305 48.0467 89.2905 45.26 80.4238 45.26C62.4372 45.26 52.3038 55.3933 50.0238 75.66C50.0238 78.1933 48.6305 79.2067 45.8438 78.7L4.04383 71.86C1.5105 71.3533 0.497162 69.8333 1.00383 67.3C1.76383 58.4333 4.04383 49.9467 7.84383 41.84C11.6438 33.7333 16.9638 26.64 23.8038 20.56C30.8972 14.48 39.2572 9.66664 48.8838 6.11998C58.7638 2.31998 69.9105 0.419983 82.3238 0.419983C94.7372 0.419983 105.757 2.31998 115.384 6.11998C125.264 9.91999 133.624 15.1133 140.464 21.7C147.304 28.2867 152.497 36.14 156.044 45.26C159.844 54.1267 161.744 63.7533 161.744 74.14C161.744 86.5533 159.337 97.8267 154.524 107.96C149.964 117.84 143.631 127.467 135.524 136.84L67.5038 217.02V217.78H157.944C160.477 217.78 161.744 219.047 161.744 221.58V259.2C161.744 261.733 160.477 263 157.944 263H4.42383C1.8905 263 0.62383 261.733 0.62383 259.2V223.86Z" fill="url(#paint0_linear_718_34525)"></path>
          <defs>
            <linearGradient id="paint0_linear_718_34525" x1="82" y1="-2" x2="82" y2="272" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FFA8A8"></stop>
              <stop offset="1" stop-color="#F1F1F1"></stop>
            </linearGradient>
          </defs>
        </svg>
        <h1>أندية مونجلش التفاعلية</h1>
        <p>
          رحلة ممتعة إلى عالم مونجلش المليء بالمغامرات!
          في أندية مونجلش التفاعلية، كل باب نفتحه يأخذنا
          إلى عالم ساحر من الألعاب والقصص التي تجعل
          تعلم اللغة الإنجليزية رحلة شيقة.
        </p>
      </div>
      <div class="sec2-card card-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="162" height="253" viewBox="0 0 162 253" fill="none">
          <path d="M1.64047 196.8C1.16047 194.4 2.12047 192.84 4.52047 192.12L44.1205 184.56C46.2805 184.32 47.7205 185.28 48.4405 187.44C50.6005 193.92 54.3205 199.44 59.6005 204C64.8805 208.32 71.8405 210.48 80.4805 210.48C89.8405 210.48 97.1605 207.48 102.44 201.48C107.96 195.48 110.72 187.92 110.72 178.8C110.72 167.76 107.6 159.24 101.36 153.24C95.3605 147.24 87.0805 144.24 76.5205 144.24H66.0805C63.6805 144.24 62.4805 143.04 62.4805 140.64V105.72C62.4805 103.32 63.6805 102.12 66.0805 102.12H75.8005C84.9205 102.12 92.2405 99.36 97.7605 93.84C103.28 88.32 106.04 80.88 106.04 71.52C106.04 62.88 103.52 55.92 98.4805 50.64C93.6805 45.36 86.9605 42.72 78.3205 42.72C70.6405 42.72 64.5205 44.76 59.9605 48.84C55.6405 52.92 52.5205 58.44 50.6005 65.4C49.8805 67.56 48.4405 68.4 46.2805 67.92L7.04047 60.36C4.64047 59.88 3.68047 58.56 4.16047 56.4C5.60047 48.24 8.36047 40.8 12.4405 34.08C16.5205 27.12 21.8005 21.12 28.2805 16.08C35.0005 11.04 42.6805 7.19999 51.3205 4.55999C60.2005 1.67999 70.0405 0.239984 80.8405 0.239984C92.8405 0.239984 103.52 1.91998 112.88 5.27998C122.24 8.63998 130.16 13.32 136.64 19.32C143.12 25.32 148.04 32.52 151.4 40.92C154.76 49.08 156.44 58.08 156.44 67.92C156.44 78.48 154.04 88.08 149.24 96.72C144.68 105.36 137.96 112.56 129.08 118.32V119.04C132.68 120.96 136.4 123.6 140.24 126.96C144.08 130.32 147.56 134.52 150.68 139.56C153.8 144.36 156.32 150 158.24 156.48C160.16 162.96 161.12 170.28 161.12 178.44C161.12 189.72 159.08 199.92 155 209.04C151.16 218.16 145.64 225.96 138.44 232.44C131.24 238.92 122.72 243.96 112.88 247.56C103.28 251.16 92.7205 252.96 81.2005 252.96C60.3205 252.96 42.6805 248.04 28.2805 238.2C13.8805 228.36 5.00047 214.56 1.64047 196.8Z" fill="url(#paint0_linear_718_34532)"></path>
          <defs>
            <linearGradient id="paint0_linear_718_34532" x1="82" y1="-6" x2="82" y2="268" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FD9749"></stop>
              <stop offset="1" stop-color="#F1F1F1"></stop>
            </linearGradient>
          </defs>
        </svg>
        <h1>تقارير متابعة للأداء اليومي</h1>
        <p>
          لدينا سجل مغامرات خاص لكل بطل صغير! هذا
          السجل سيخبرك بأداء طفلك و تقدمة كل يوم. و هذا
          سوف يساعدك على معرفة ما يحتاج إليه طفلك
          لممارسته أكثر، ويظهر لك كيف يصبح أفضل
        </p>
      </div>
    </div>
  </div>

  <!--Section Three Content-->
  <div class="content-slider-container">
    <!-- Text Content Section -->
    <div class="text-content">
      <h1>طفلك يستحق التميّز! 🌟</h1>
      <p>
        في Monglish، نُساعد الأطفال على بناء ثقتهم بأنفسهم وتطوير لغتهم في بيئة محفّزة وممتعة.
        لا مزيد من الحفظ أو التلقين..التعلم معنا ممتع، تطبيقي، وفعّال.
        دعنا نساعد طفلك يبدأ رحلته الآن نحو إجادة الإنجليزية
      </p>
      <button @click="sendMessage" id="kids-wa3-ar">
        احجز التجربة المجانية الآن
        <img src="https://monglish.b-cdn.net/kids-landing/Whatsapp.png" alt="whatsapp icon">
      </button>
    </div>

    <!-- Slider Section -->
    <div class="video-slider-component">
      <div class="slider-container">
        <button class="slider-nav left" @click="prevSlide">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"/>
          </svg>
        </button>
        <div class="image-container">
          <img :src="currentImage.src" :alt="currentImage.alt" @click="openPopup(currentImage.videoSrc)" class="image-thumbnail"/>
          <svg height="80px" width="80px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 491.444 491.444" xml:space="preserve" fill="#000000" class="video-icon">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path style="fill: #ff9d52" d="M0.11,245.721c-1.434,61.225,11.068,122.791,39.645,145.883c80.101,64.726,331.832,64.726,411.932,0c28.577-23.093,41.079-84.659,39.646-145.883H0.11z"></path>
              <path style="fill: #f47d21" d="M451.687,105.91c-72.82-72.82-339.111-72.82-411.932,0C15.231,130.434,1.463,187.925,0.11,245.721h491.223C489.98,187.925,476.213,130.434,451.687,105.91z"></path>
              <path style="fill: #ffffff" d="M320.941,232.105L190.51,136.284c-11.159-8.199-26.9-0.231-26.9,13.617v95.82h164.225C327.834,240.6,325.537,235.481,320.941,232.105z"></path>
              <path style="fill: #ffffff" d="M190.51,355.161l130.432-95.823c4.595-3.375,6.893-8.496,6.893-13.617H163.609v95.824C163.609,355.391,179.351,363.359,190.51,355.161z"></path>
            </g>
          </svg>
        </div>
        <button class="slider-nav right" @click="nextSlide">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Popup Overlay -->
    <div v-if="isPopupOpen" class="popup-overlay" @click="closePopup">
      <div class="popup-content" @click.stop>
        <button class="close-button" @click="closePopup">&times;</button>
        <iframe v-if="currentVideoSrc" :src="currentVideoSrc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="popup-video"></iframe>
      </div>
    </div>
  </div>

  <!--Section Four Content-->
  <div class="kids-sec4">
    <h2>اعتماداتنا الدولية تُعني جودة مضمونة</h2>
    
    <p>
      أكاديمية مونجلش الدولية معتمدة دولياً من مؤسسات بارزة مثل المنظمة الدولية لجودة التدريب (IOTQ) وحاصلة على شهادة ISO 9001:2015 من الاتحاد الأمريكي للاعتماد (UAF) <br/>
      .نحن أيضاً أعضاء في الجمعية الأمريكية للاعتماد (AAA)، الجمعية المصرية للجودة (ESQ)، ومنظمة الجودة العربية (AROQA) تحت مظلة طلال أبو غزالة (TAG-ORG)، مما يعكس التزامنا <br/> بالمعايير العالمية للتعليم العالي.
    </p>

    <button @click="sendMessage" id="kids-wa5-ar">
      إشترك معنا الأن
      <img src="https://monglish.b-cdn.net/kids-landing/Whatsapp.png" alt="whatsapp icon">
    </button>

    <div class="kids-sec4-imgs">
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/1.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/2.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/3.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/4.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/5.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/6.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/7.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/8.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/9.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/10.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/11.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/12.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/13.webp" />
      <img src="https://monglish.b-cdn.net/kids-landing/accreditations/14.webp" />
    </div>
  </div>

  <!--Section Five Content-->
  <div class="kids-sec5">
    <img src="https://monglish.b-cdn.net/kids-landing/kids/Vector.png" alt="vector" class="vector-img"/>
    <div class="kids-sec8-row" style="direction: rtl">
      <h4>تعرف علي أندية <br />مونجلش التفاعلية</h4>
      <p>
        استكشف أندية مونجلش التفاعلية التي توفر لطفلك فرصة فريدة للتعلم بطريقة
        ممتعة ومبتكرة! تقدم هذه الأندية مجموعة متنوعة من الأنشطة المصممة لتعزيز
        مهارات اللغة والتواصل، مما يجعل عملية التعلم تجربة مليئة بالمرح
        والتفاعل. في أندية مونجلش، نؤمن بأهمية دمج التعلم باللعب، حيث سيستمتع
        طفلك بتجربة تعليمية غنية تساعده على تطوير ثقته بنفسه وقدراته اللغوية
        بشكل فعّال ومشوق!
      </p>
    </div>
    <ImmerseClubs />
  </div>

  <!--Section Six Content-->

  <!--Section Seven Content-->
  <div class="kids-sec8">
    <div class="kids-sec8-row">
      <h4>الآراء الإيجابية <br/><span> لأولياء الأمور</span></h4>
      <!-- <p>
        نظرا للتفوق المبهر الذي يحققه خريجو أكاديمية مونجلش الدولية، خصوصا
        بالنسبة للأطفال والمراهقين، فإن أولياء أمورهم فخورين بما وصل إليه
        أبنائهم، وسعادتهم بالتطوير السريع الذي شهده أبنائهم والتي يعربون عنها في
        كل مناسبة تجعلنا نشعر بالفخر أكثر، وتزيدنا عزما على الاجتهاد من أجل
        التطوير والتحسين المستمر للدورات التي نقدمها، من أجل الوصول إلى أفضل
        النتائج لطلابنا دائما. إن مونجلش وصلت إلى ما وصلت إليه بدعم هؤلاء
        الرائعين!
      </p> -->
    </div>

    <ReviewSwiper />
  </div>

  <!--Section Seven Content-->
  <!-- <PackagesFoundation /> -->
  <div ref="packagesSection">
    <PackagesKids />
  </div>

  <!--Section Eight Content-->
  <div class="kids-sec9">
    <!-- Title at the top -->
    <h2>
      نعدكم بتجربة فريدة في تعليم اللغة الإنجليزية <br />
      للأطفال من خلال رحلة تعليمية تفاعلية ومتكاملة
    </h2>

    <!-- Content section (text and image in a row) -->
    <div class="kids-sec9-content">
      <div class="kids-sec9-text">
        <p>
          “باختيارك أكاديمية مونجلش الدولية فأنت على الطريق الصحيح لإتقان اللغة
          الإنجليزية والتحدث بها كأهل اللغة في أقصر وقت”
        </p>
      </div>
      <div class="kids-sec9-images">
        <img src="https://monglish.b-cdn.net/kids-landing/kids/sec11.png" />
      </div>
    </div>
  </div>

  <!-- <PackagesBundleK ref="packagesSection" /> -->

  <!-- <PackagesFoundation /> -->

  <!--Section Ten Content-->
  <FormSection />
  <Popup :show="showPopup" @close="showPopup = false" />
</template>

<script>
import ImmerseClubs from "../../components/ar/ImmerseClubs.vue";
// import PackagesBundleK from "../../components/ar/PackagesBundleK.vue";
// import PackagesBundleF from "../../components/ar/PackagesBundleF.vue";
import FormSection from "../../components/ar/FormSection.vue";
import ReviewSwiper from "../../components/ar/ReviewSwiper.vue";
// import PackagesFoundation from "../../components/ar/PackagesFoundation.vue";
import PackagesKids from "../../components/ar/PackagesKids.vue";
import Popup from "../../components/ar/PopUp4.vue";

import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";

export default {
  name: "KidsCourses",
  components: {
    ImmerseClubs,
    // PackagesBundleK,
    // PackagesBundleF,
    // PackagesFoundation,
    PackagesKids,
    FormSection,
    ReviewSwiper,
    Popup
  },
  data() {
    return {
      showPopup: false,
      delayId: null,
      activeDescription: null,
      isPopupOpen: false,
      currentVideoSrc: "",
      currentSlide: 0,
      images: [
        {
          videoSrc: "https://www.youtube.com/embed/jdWsjo_IpWE?autoplay=1",
          src: "https://monglish.b-cdn.net/kids-landing/video/7.png",
          alt: "Video 2 Thumbnail",
        },
        {
          videoSrc: "https://www.youtube.com/embed/4G2OnuPdyww?autoplay=1",
          src: "https://monglish.b-cdn.net/kids-landing/video/6.png",
          alt: "Video 1 Thumbnail",
        },
      ],
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentSlide];
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
      window.addEventListener("resize", this.handleResize);
    });

    const popupShown = sessionStorage.getItem('popupShown');
    if (!popupShown) {
      this.delayId = setTimeout(() => {
        this.showPopup = true;
      }, 7500);
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);

    if (this.delayId) clearTimeout(this.delayId);
  },
  methods: {
    async fetchRedirectUrl(landingPageSlug) {
      try {
        const response = await axios.get(`/api/landing-pages/${landingPageSlug}/redirect`);
        return response.data.redirect_url;
      } catch (error) {
        console.error('Error fetching redirect URL:', error);
        // Fallback to a default URL or handle error
        return null;
      }
    },
    async callToAction() {
      // window.location.href = "https://monglish.zohobookings.com/#/4757440000000046052";
      // window.location.href = "https://forms.gle/qxFyV8o9Uoh4ge5z8";
      const redirectUrl = await this.fetchRedirectUrl('kids-landing');
      if (redirectUrl) {
        window.location.href = redirectUrl;      
      } else {
        // Handle error - maybe show a message or use fallback URL
        console.error('Could not get redirect URL');
      }
    },

    async sendMessage() {
      try {
        const response = await fetch(
          `https://service.edulixa360.com/api/get-phone-number`
        );
        if (!response.ok) {
          console.log("Network response was not ok");
        }
        const data = await response.json();
        this.getNumber = data.phone_number;

        if (this.getNumber) {
          const baseUrl =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent
            )
              ? "whatsapp://send"
              : "https://web.whatsapp.com/send";

          // Encode the Arabic message
          const arabicMessage = encodeURIComponent(
            "تفاصيل منهج المعايشة للأطفال"
          );

          // Create the WhatsApp URL with the predefined message
          const url = `${baseUrl}?phone=${this.getNumber}&text=${arabicMessage}`;

          // Open WhatsApp
          window.open(url, "_blank");
        }
      } catch (error) {
        console.error("Error fetching phone number:", error);
      }
    },

    initSwiper() {
      const swiperContainer = this.$refs.swiperContainer;
      if (swiperContainer) {
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }

        this.swiper = new Swiper(swiperContainer, {
          loop: true,
          slidesPerView: window.innerWidth <= 768 ? 1 : 3,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
        this.startAutoNavigate();
      }
    },

    openPopup(videoSrc) {
      this.currentVideoSrc = videoSrc;
      this.isPopupOpen = true;
    },
    closePopup() {
      this.isPopupOpen = false;
      this.currentVideoSrc = "";
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.images.length;
    },
    prevSlide() {
      this.currentSlide =
        (this.currentSlide - 1 + this.images.length) % this.images.length;
    },
    startAutoNavigate() {
      setInterval(() => {
        if (this.swiper) {
          this.swiper.slideNext();
        }
      }, 3000);
    },
    toggleDescription(id) {
      this.activeDescription = this.activeDescription === id ? null : id;
    },
    scrollToPackagesWithDelay() {
      setTimeout(() => {
        const packagesSection = this.$refs.packagesSection;
        if (packagesSection && packagesSection.scrollIntoView) {
          packagesSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    },
  },
  watch: {
    "$route.hash"() {
      this.scrollToPackagesWithDelay();
    },
  },
};
</script>

<style scoped>
/*section 1 style */
.kids-sec1 {
  background-image: url("https://monglish.b-cdn.net/kids-landing/hero-section-bg.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  color: #fff;
  text-align: right;
  padding: 0 4rem 2rem 4rem;
  min-height: 100vh;
  direction: rtl;
  z-index: 0;
  display: flex;
  align-items: center;
  margin-top: -85px;
}
.kids-sec1::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.text-container {
  max-width: 40%;
  position: relative;
  z-index: 2;
  padding: 2rem 2rem 4rem 2rem;
}
.kids-sec1 h3,
.kids-sec1 h1,
.kids-sec1 h2,
.kids-sec1 p {
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

/* Large desktop */
.kids-sec1 h3 {
  font-size: 30px;
  line-height: 35px;
}

.kids-sec1 h1 {
  font-size: 54px;
  line-height: 75px;
}

.kids-sec1 h2 {
  font-size: 42px;
  line-height: 45px;
}

.kids-sec1 p {
  font-size: 20px;
  line-height: 29px;
}

.kids-sec1 .group-btns {
  display: flex;
  gap: 15px;
}

.kids-sec1 button {
  background: #FF760B;
  border-radius: 12px;
}

.kids-sec2 button,
.kids-sec4 button {
  background: linear-gradient(45deg, #fe9b4f, #f77919);
  border-radius: 25px;
}

.kids-sec1 button,
.kids-sec2 button,
.kids-sec4 button {
  display: flex;
  gap: 10px;
  max-width: 50%;
  padding: 0.5rem 2.5rem 1rem 2.5rem;
  background: linear-gradient(45deg, #fe9b4f, #f77919);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  margin-top: 1.5rem;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
  transition: background 0.3s ease, transform 0.3s ease;
}

.kids-sec1 .orange-btn {
  max-width: 55%;
}

.kids-sec1 .white-btn {
  background: #ffffff;
  color: #F47D21;
  border-radius: 12px;
  border: 1px solid #F47D21;
}

.kids-sec4 button {
  margin-bottom: 20px;
}

.kids-sec2 button:hover,
.kids-sec4 button:hover {
  background: linear-gradient(45deg, #f47e23, #fe9b4f);
  transform: scale(1.05);
}

/* Laptop view */
@media (max-width: 1440px) {
  .kids-sec1 {
    padding: 3rem 2rem;
  }

  .text-container {
    max-width: 45%;
    padding: 3rem 1.5rem;
  }

  .kids-sec1 h1 {
    font-size: 40px;
    line-height: 50px;
  }

  .kids-sec1 h2 {
    font-size: 26px;
    line-height: 30px;
  }

  .kids-sec1 p {
    font-size: 18px;
    line-height: 26px;
  }
}

/* Tablet view */
@media (max-width: 1280px) {
  .kids-sec1 h1 {
    font-size: 38px;
    line-height: 50px;
  }

  .kids-sec1 h2 {
    font-size: 24px;
    line-height: 25px;
  }

  .kids-sec1 p {
    font-size: 18px;
    line-height: 25px;
  }
}

/* Mobile view */
@media (max-width: 768px) {
  img {
    width: auto;
  }
  .kids-sec1 {
    background-image: url("https://monglish.b-cdn.net/kids-landing/hero-section-bg-sm.png");
    text-align: center;
    padding: 1rem;
    z-index: 0;
  }

  .kids-sec1::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(64, 64, 64, 0) 30%, #1e1e1e 100%);
    z-index: 1;
  }

  .text-container {
    max-width: 100%;
    padding-top: 90%;
  }

  .kids-sec1 h3 {
    font-size: 20px;
    line-height: 20px;
  }

  .kids-sec1 h1 {
    font-size: 30px;
    line-height: 30px;
  }

  .kids-sec1 h2 {
    font-size: 24px;
    line-height: 30px;
  }

  .kids-sec1 p {
    font-size: 16px;
    line-height: 22px;
  }

  .kids-sec1 .group-btns {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
  }

  .kids-sec1 button, .kids-sec4 button {
    max-width: 80%;
  }

  .kids-sec1 .orange-btn {
    max-width: 85%;
  }
}

/* Small mobile view */
@media (max-width: 480px) {
  img {
    width: auto;
  }
  .text-container {
    max-width: 100%;
    padding: 0;
    padding-top: 100%;
  }
  .text-container h3 {
    font-weight: bold;
    font-size: 23px;
    line-height: 1px;
  }

  .kids-sec1 h1 {
    font-size: 22px;
    line-height: 30px;
  }

  .kids-sec1 h2 {
    font-size: 20px;
    line-height: 23px;
  }

  .kids-sec1 p {
    font-size: 17px;
    line-height: 23px;
  }

  .kids-sec1 .orange-btn {
    max-width: 85%;
  }
}

/*section 2 style*/
.kids-sec2 {
  direction: rtl;
  text-align: center;
  background-color: #fff;
  color: #165e84;
  font-weight: 500;
  padding: 2em 1em;
}
.kids-space {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4em 2em;
}
.kids-space h1 {
  font-size: 3em;
  font-family: "DIN Next LT Arabic";
  font-weight: 700;
  line-height: 50px;
}
.kids-space h3 {
  font-size: 2.3em;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
  line-height: 40px;
}
.kids-sec2-cards {
  display: flex;
  justify-content: center;
  gap: 3em;
  padding: 3em;
  flex-wrap: wrap;
}
.sec2-card {
  border-radius: 1em;
  padding: 1em;
  flex: 1 1 15em;
  max-width: 95%;
  height: 30em;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: rgba(104, 104, 104, 0.3) 1px solid;
  margin-bottom: 1em;
}
.sec2-card.card-1 {
  background: linear-gradient(180deg, #d9d9d900 0%, #eff6fe 100%);
}
.sec2-card.card-2 {
  background: linear-gradient(180deg, #d9d9d900 0%, #faebeb 100%);
}
.sec2-card.card-3 {
  background: linear-gradient(180deg, #d9d9d900 0%, #ffefe3 100%);
}
.sec2-card svg {
  width: 100%;
  height: 100%;
  margin-bottom: 3em;
  margin-top: -6em;
}
.sec2-card h1 {
  font-size: 2.3em;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
}
.sec2-card p {
  font-size: 1.3em;
  color: #666;
  margin: 0 1em;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
}
@media (max-width: 768px) {
  .kids-space h1 {
    font-size: 2em;
    line-height: 30px;
  }
  .kids-space h3 {
    font-size: 1.6em;
    line-height: 30px;
  }
  .sec2-card {
    flex: 1 1 100%;
    max-width: 100%;
  }
  .sec2-card h1 {
    font-size: 1.5em;
  }
  .sec2-card p {
    font-size: 1em;
  }
  .kids-sec2 button {
    max-width: 100%;
  }
}
@media (max-width: 480px) {
  .kids-space {
    padding-bottom: 0;
  }
  .kids-space h1 {
    font-size: 1.5em;
  }
  .kids-space h3 {
    font-size: 1.3em;
  }
  .sec2-card {
    height: auto;
  }
  .sec2-card svg {
    width: 80px;
    height: 120px;
    margin-top: 0;
    margin-bottom: 0;
  }
  .sec2-card h1 {
    font-size: 1.2em;
  }
  .sec2-card p {
    font-size: 0.9em;
  }
  .kids-sec2-cards {
    gap: 1em;
  }
}

/* Section 3 style */
.content-slider-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  direction: rtl;
  background-image: url("https://monglish.b-cdn.net/kids-landing/vid.png");
  background-size: cover;
  background-position: center;
  overflow-x: hidden;
}

.text-content {
  flex: 1;
  padding-right: 5%;
}

.content-slider-container h1 {
  color: #165e84;
  font-size: 48px;
  font-weight: 500;
  font-family: "DIN Next LT Arabic";
  margin-bottom: 3%;
}

.content-slider-container h2 {
  color: #3d3d3d;
  font-size: 40px;
  font-weight: 500;
  font-family: "DIN Next LT Arabic";
  line-height: 52px;
}

.text-content h2 span {
  color: #165e84;
  line-height: 52px;
}

.text-content p {
  color: #4b4b4b;
  font-size: 20px;
  width: 90%;
  margin-bottom: 2%;
  font-weight: 500;
  font-family: "DIN Next LT Arabic";
}

.text-content button {
  display: flex;
  gap: 10px;
  padding: 12px;
  background: linear-gradient(45deg, #fe9b4f, #f47e23);
  color: white;
  border: none;
  border-radius: 25px;
  width: 40%;
  cursor: pointer;
  font-size: 20px;
}

.video-slider-component {
  flex: 1;
}

.slider-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container {
  position: relative;
  display: inline-block;
}

.image-thumbnail {
  width: 350px;
  height: 600px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 30px;
}

.video-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  transition: transform 0.3s ease;
  pointer-events: none;
}

.image-container:hover .video-icon {
  transform: translate(-50%, -50%) scale(1.5);
}

.slider-nav {
  color: #165e84;
  cursor: pointer;
  position: absolute;
  z-index: 10;
  background-color: transparent;
  transition: color 0.3s ease;
  border: none;
}
.slider-nav svg {
  width: 50px;
  height: 50px;
}

.slider-nav.left {
  left: 5vw;
}

.slider-nav.right {
  right: 5vw;
}

.slider-nav:hover {
  color: #2178a6;
}

.slider-nav:active {
  color: #fff;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  width: 26vw;
  height: 95vh;
  overflow: hidden;
  position: relative;
}

.popup-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@keyframes popupIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.close-button {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 5rem;
  cursor: pointer;
  transition: color 0.3s ease;
  color: #fff;
  background-color: transparent;
  border: none;
}

.close-button:hover {
  color: #d9534f;
}
@media (max-width: 850px) {
  .content-slider-container {
    display: block;
  }

  .content-slider-container h1 {
    font-size: 28px;
  }

  .slider-nav.left {
    left: 0;
  }

  .slider-nav.right {
    right: 0;
  }

  .popup-content {
    width: 90%;
    height: auto;
  }

  .popup-video {
    height: calc(100vw * (16 / 9));
    width: 100%;
  }

  .slider-nav svg {
    width: 30px;
    height: 30px;
  }

  .slider-nav.left {
    left: 70%;
  }

  .slider-nav.right {
    right: 70%;
  }

  .carousel-track {
    justify-content: center;
  }

  .item {
    transform: none !important;
    opacity: 1 !important;
  }

  .image-thumbnail {
    width: 350px;
    height: 600px;
    object-fit: cover;
    cursor: pointer;
    border-radius: 30px;
  }
  .text-content h1,
  .text-content p,
  .text-content h2,
  .text-content button {
    padding-right: 0;
    padding-left: 0;
    text-align: center;
    width: 100%;
  }
  .content-slider-container p {
    font-size: 19px;
  }
  .content-slider-container button {
    padding-right: 0;
    padding-left: 0;
    text-align: center;
    width: 60%;
    margin: 0 auto;
    display: block;
  }
}

/* Section 4 style */
.kids-sec4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  direction: rtl;
  text-align: center;
  color: #808080;
  padding: 2em 2em 8em 2em;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
}

/* Large desktop */
.kids-sec4 h3 {
  font-size: 30px;
  line-height: 30px;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
}

.kids-sec4 h2 {
  font-size: 42px;
  line-height: 30px;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
}

.kids-sec4 p {
  font-size: 20px;
  line-height: 29px;
  padding: 0 10%;
}

/* Laptop view */
@media (max-width: 1440px) {
  .kids-sec4 {
    padding: 3rem 2rem;
  }

  .kids-sec4 h2 {
    font-size: 26px;
    line-height: 30px;
  }

  .kids-sec4 p {
    font-size: 18px;
    line-height: 26px;
  }
}

/* Tablet view */
@media (max-width: 1280px) {
  .kids-sec4 h2 {
    font-size: 24px;
    line-height: 25px;
  }

  .kids-sec4 p {
    font-size: 18px;
    line-height: 25px;
  }
}

/* Mobile view */
@media (max-width: 768px) {
  .kids-sec4 h3 {
    font-size: 23px;
    line-height: 28px;
  }

  .kids-sec4 h2 {
    font-size: 27px;
    line-height: 32px;
  }

  .kids-sec4 p {
    font-size: 18px;
    line-height: 22px;
  }
}

/* Small mobile view */
@media (max-width: 480px) {
  .kids-sec4 h2,
  .kids-sec4 h3 {
    font-size: 22px;
    line-height: 20px;
    color: #165e84;
  }

  .kids-sec4 p {
    font-size: 17px;
    line-height: 30px;
    padding: 0;
  }

  .kids-sec4 button {
    max-width: 70%;
    font-size: 1.1rem;
    margin-bottom: 5%;
    margin-top: 0;
  }
}

.kids-sec4-imgs {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 3em;
  padding: 0 6%;
}
.kids-sec4-imgs img {
  width: 10%;
}
@media (max-width: 1200px) {
  .kids-sec4-imgs img {
    width: 12%;
  }
}
@media (max-width: 992px) {
  .kids-sec4-imgs img {
    width: 15%;
  }
}
@media (max-width: 768px) {
  .kids-sec4-imgs img {
    width: 20%;
  }
}
@media (max-width: 576px) {
  .kids-sec4-imgs img {
    width: 25%;
  }
}
@media (max-width: 400px) {
  .kids-sec4-imgs img {
    width: 30%;
  }
}

/* Section 5 style */
.kids-sec5 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("https://monglish.b-cdn.net/kids-landing/kids/sec3-bg.jpg");
  background-size: cover;
  background-position: center;
  text-align: center;
  padding: 2rem 0 0 0;
}
.kids-sec5 h1 {
  font-size: 2.8rem;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
  color: #165e84;
  padding: 2em;
}
.vector-img {
  margin-top: -7.5em;
}
@media (max-width: 1440px) {
  .vector-img {
    margin-top: -6.5em;
    width: 150px;
  }
}

@media (max-width: 1280px) and (max-height: 720px) {
  .vector-img {
    margin-top: -5.5em;
    width: 120px;
  }
}

@media (max-width: 1280px) and (min-height: 1024px) {
  .vector-img {
    margin-top: -5.5em;
    width: 120px;
  }
}

@media (max-width: 768px) {
  .kids-sec5 {
    height: auto;
    padding: 1rem;
  }
  .kids-sec5 h1 {
    font-size: 2rem;
    padding: 1rem;
  }
  .vector-img {
    margin-top: -4em;
    width: 100px;
  }
}
@media (max-width: 480px) {
  .kids-sec5 h1 {
    font-size: 1.5rem;
    padding: 0.5rem;
  }
  .vector-img {
    margin-top: -2.5em;
    width: 50px;
  }
}

/* Section 7 style */
.kids-sec7 {
  background-color: #fff;
  text-align: center;
  color: #165e84;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  width: 100%;
  position: relative;
  align-items: center;
  overflow: hidden;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
  padding: 2em 0;
}
.corner2-img {
  position: absolute;
  top: 0;
  right: 10%;
  width: 8%;
  height: auto;
}
.kids-sec7 h1 {
  font-size: 3em;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
  margin: 0.5em;
}
.kids-sec7 p {
  font-size: 1.3em;
  padding: 0 20%;
  padding-bottom: 3%;
}
@media (max-width: 480px) {
  .kids-sec7 h1 {
    font-size: 2em;
    margin: 0;
  }
  .kids-sec7 p {
    font-size: 1.2em;
    padding: 0 8%;
    padding-bottom: 1%;
  }
}

/* Section 8 style */
.kids-sec8 {
  padding: 2%;
  background-color: white;
  background-position: center;
  text-align: center;
  height: auto;
}
.kids-sec8-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 1em;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
  color: #165e84;
  direction: rtl;
}
.kids-sec8-row h4 {
  font-size: 2.5vw;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
}
.kids-sec8-row span {
  font-size: 3.2vw;
  font-family: "DIN Next LT Arabic";
  font-weight: 700;
}
.kids-sec8-row p {
  font-size: 1.3rem;
  color: gray;
  max-width: 75%;
  margin: 0 auto;
}
@media (min-width: 769px) {
  .kids-sec8-row {
    flex-direction: row;
    justify-content: center;
    text-align: center;
  }
  .kids-sec8-row h4 {
    width: 40%;
    margin: 0;
    padding-left: 1em;
  }
  .kids-sec8-row p {
    width: 70%;
    margin: 0;
    padding-right: 1em;
  }
}
@media (max-width: 768px) {
  .kids-sec8 {
    margin-bottom: 2rem;
  }
  .kids-sec8-row h4 {
    font-size: 25px;
    width: 100%;
  }
  .kids-sec8-row h4 span {
    font-size: 25px;
    width: 100%;
  }
  .kids-sec8-row p {
    font-size: 1.2rem;
    max-width: 100%;
  }
}

/* Section 9 style */
.kids-sec9 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 1em;
  background-color: #fff;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
  color: #4e5354;
  position: relative;
  direction: rtl;
  overflow-x: hidden;
}

.kids-sec9 h2 {
  text-align: center;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #165e84;
  font-family: "DIN Next LT Arabic";
  width: 100%;
}

.kids-sec9-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.kids-sec9-text {
  text-align: center;
}

.kids-sec9-text p {
  font-weight: 400;
  line-height: 1.6;
}

@media (min-width: 769px) {
  .kids-sec9-content {
    flex-direction: row;
    justify-content: space-between;
  }

  .kids-sec9-text {
    width: 50%;
    text-align: center;
    padding-right: 2em;
  }

  .kids-sec9-text p {
    font-size: 1.5rem;
    padding: 0 25%;
  }
  .kids-sec9 h2 {
    font-size: 2.7rem;
  }

  .kids-sec9-images {
    width: 50%;
    display: flex;
    justify-content: center;
  }

  .kids-sec9-images img {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .kids-sec9-text h2 {
    font-size: 28px;
  }
  .kids-sec9-text p {
    font-size: 22px;
  }
  .kids-sec9-images img {
    width: 100%;
  }
}

/* Section 10 style */
.kids-sec10-space {
  padding: 0 50px;
  background-color: #fff;
}
.kids-sec10 {
  position: relative;
  width: 100%;
  height: 70vh;
  background-image: url("https://monglish.b-cdn.net/kids-landing/kids/sec12.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 25px;
  overflow: hidden;
  transform: scale(0.9);
}
.kids-sec10-inner {
  border-radius: 25px;
  padding: 20px;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.kids-sec10-content {
  position: relative;
  z-index: 1;
  color: #fff;
  text-align: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: "DIN Next LT Arabic";
  font-weight: 500;
}
.kids-sec10-content h1 {
  font-size: 3.3rem;
  font-family: "DIN Next LT Arabic-n";
  font-weight: 700;
}
.kids-sec10-content p {
  font-size: 1.5rem;
  max-width: 80%;
  line-height: 1.6;
}
@media (max-width: 1200px) {
  .kids-sec10-content h1 {
    font-size: 2.5rem;
  }
  .kids-sec10-content p {
    font-size: 1.2rem;
    max-width: 90%;
  }
}
@media (max-width: 992px) {
  .kids-sec10 {
    height: 60vh;
  }
  .kids-sec10-content h1 {
    font-size: 2rem;
  }
  .kids-sec10-content p {
    font-size: 1rem;
    max-width: 95%;
  }
}
@media (max-width: 768px) {
  .kids-sec10 {
    height: 50vh;
    padding: 10px;
  }
  .kids-sec10-content h1 {
    font-size: 1.8rem;
  }
  .kids-sec10-content p {
    font-size: 0.9rem;
    max-width: 100%;
  }
}
@media (max-width: 576px) {
  .kids-sec10 {
    height: 40vh;
  }
  .kids-sec10-content h1 {
    font-size: 1.5rem;
  }
  .kids-sec10-content p {
    font-size: 0.8rem;
    max-width: 100%;
  }
}
</style>
